/* eslint-disable @typescript-eslint/naming-convention */
import getEnv from "@utils/getEnv";

export const COORDINATES = {
  lt: "55.169437,23.881275",
  lv: "56.879635,24.603189",
  ee: "59.436962,24.753574",
};

export const ADDRESS_SEARCH_API_KEYS = {
  lt: getEnv("NEXT_PUBLIC_HERE_API_KEY_LT"),
  lv: getEnv("NEXT_PUBLIC_HERE_API_KEY_LV"),
  ee: getEnv("NEXT_PUBLIC_HERE_API_KEY_EE"),
};

export const ADDRESS_SEARCH_BASE_URL = getEnv("NEXT_PUBLIC_HERE_AUTOCOMPLETE_API_URL");
export const LOOKUP_SEARCH_BASE_URL = getEnv("NEXT_PUBLIC_HERE_LOOKUP_API_URL");
